import { ContractPlan } from '@crew/enums/app'
import dayjs from '@crew/modules'
import { useMemo } from 'react'
import { useAppSelector } from 'states/hooks'

export type PaidFeatureStatus = {
  /** 有償機能が利用可能かどうか */
  canUsePaidFeature: boolean
  /** 現在試用期間中かどうか */
  isTrialPeriod: boolean
}

// 契約プランと有償プラン試用期限を元に、有償機能の利用状況を返すカスタムフック
export const usePaidFeatureStatus = (): PaidFeatureStatus => {
  const currentPlan = useAppSelector((state) => state.app.currentPlan)
  const paidPlanTrialExpirationDatetime = useAppSelector(
    (state) => state.app.paidPlanTrialExpirationDatetime
  )

  return useMemo(() => {
    return getPaidFeatureStatus(currentPlan, paidPlanTrialExpirationDatetime)
  }, [currentPlan, paidPlanTrialExpirationDatetime])
}

/**
 * 契約プランと有償プラン試用期限を元に、有償機能の利用状況を返す
 */
export const getPaidFeatureStatus = (
  contractPlan: ContractPlan | null,
  paidPlanTrialExpirationDatetime: string | null
): PaidFeatureStatus => {
  // 契約プランが設定されていない場合は利用不可
  if (!contractPlan) {
    return {
      canUsePaidFeature: false,
      isTrialPeriod: false,
    }
  }

  // フリープラン以外は有償機能利用可能（試用期間ではない）
  if (contractPlan !== ContractPlan.Free) {
    return {
      canUsePaidFeature: true,
      isTrialPeriod: false,
    }
  }

  // フリープランの場合、有償プラン試用期間が設定されていない場合は利用不可
  if (!paidPlanTrialExpirationDatetime) {
    return {
      canUsePaidFeature: false,
      isTrialPeriod: false,
    }
  }

  // フリープランの場合、有償プラン試用期間中であれば有償機能利用可能
  const isBeforeExpiration = dayjs()
    .utc()
    .isBefore(dayjs(paidPlanTrialExpirationDatetime).utc())

  return {
    canUsePaidFeature: isBeforeExpiration,
    isTrialPeriod: isBeforeExpiration,
  }
}
